module.exports = __webpack_public_path__ + "img/shape-17.5b94acdc.png";